import React from "react";
import { useTranslation } from "react-i18next";
import type { Phase } from "../../types";

interface PhaseIndicatorProps {
  phase: Phase;
}

export const PhaseIndicator: React.FC<PhaseIndicatorProps> = ({ phase }) => {
  const { t } = useTranslation();
  const phaseKeys: Phase[] = ["analyzing", "searching", "drafting", "verifying"];
  const currentIndex = phaseKeys.indexOf(phase);

  const label = t(`phases.${phase}.label`, "...");
  const description = t(`phases.${phase}.description`, "...");

  return (
    <div className="flex flex-col gap-4 p-6 glass-panel rounded-3xl border-blue-500/20 bg-white/40 dark:bg-slate-900/40 max-w-sm sm:max-w-md animate-message">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-sm font-bold uppercase tracking-wider text-blue-600 dark:text-blue-400">{t("phases.title", "Tehisintellekti tööprotsess")}</h3>
        <div className="flex gap-1.5">
          {phaseKeys.map((p, i) => (
            <div
              key={p}
              className={`w-2 h-2 rounded-full transition-all duration-500 ${
                i < currentIndex
                  ? "bg-blue-500"
                  : i === currentIndex
                    ? "bg-blue-500 animate-pulse scale-125 shadow-lg shadow-blue-500/50"
                    : "bg-slate-200 dark:bg-slate-800"
              }`}
            />
          ))}
        </div>
      </div>

      <div className="space-y-1">
        <p className="text-lg font-bold text-slate-900 dark:text-white transition-all">
          {label}
        </p>
        <p className="text-sm text-slate-500 dark:text-slate-400 transition-all leading-relaxed">
          {description}
        </p>
      </div>

      <div className="relative h-1.5 w-full bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
        <div
          className="absolute top-0 left-0 h-full bg-blue-600 transition-all duration-1000 ease-in-out"
          style={{ width: `${((currentIndex + 1) / phaseKeys.length) * 100}%` }}
        />
      </div>
    </div>
  );
};
